import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "Government AC Buses (Kolkata and Howrah)";

const GovernmentACBusesKolkataHowrah = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the AC buses which are visible in and around Kolkata and
          Howrah, provided by West Bengal Transport Corporation (WBTC). The
          first of them were started in 2009 by West Bengal Surface Transport
          Corporation (WBSTC), some in partnership with private operactors and
          some owned by themselves. The next set of AC buses were launched by
          Calcutta State Transport Corportation (CSTC) in 2014. Recently
          electric buses employed by WBTC have been acclaimed for being
          environment friendly.
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default GovernmentACBusesKolkataHowrah;
